export function getResolvedOptions(formatter) {
    var options = formatter.resolvedOptions();
    // NOTE: hourCycle supports only modern browsers
    if (options.hour !== undefined && options.hourCycle === undefined) {
        options.hourCycle = options.hour12 ? 'h12' : 'h23';
    }
    return options;
}
export function formatToParts(formatter, value) {
    var parts = formatter.formatToParts(value);
    return parts.map(function (part) {
        // NOTE: chrome < 71 bug https://bugs.chromium.org/p/chromium/issues/detail?id=865351
        // @ts-expect-error
        if (part.type === 'dayperiod') {
            part.type = 'dayPeriod';
        }
        return part;
    });
}
